import React, { FC } from 'react';

import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';

import LikeAndShareBundle from '@components/share/custom/likeAndShareBundle';
import BundleHeaderPrice from '@components/templates/bundleDetail/bundleBanner/header/purchaseDetail/bundlePrice';
import BundleHeaderPurchaseDetailSkeleton from '@components/templates/bundleDetail/bundleBanner/header/purchaseDetail/skeleton';
import { BundleHeaderBannerPurchaseDetailContainer } from '@components/templates/bundleDetail/bundleBanner/header/purchaseDetail/style';
import BundleBannerPurchaseButton from '@components/templates/bundleDetail/bundleBanner/purchaseButton';
import { useBreakpointV2 } from '@helpers/use';
import useBundleBanner from '@hooks/bundle/useBundleBanner';
import useBundleCourseItem from '@hooks/bundle/useBundleCourseItem';
import useBundleDetail from '@hooks/bundle/useBundleDetail';
import { BundleEntity } from '@redux/bundle/type/BundleDetailType';

type BundleHeaderBannerPurchaseDetailProps = {
  bundleDetailSeo: BundleEntity;
};

const BundleHeaderBannerPurchaseDetail: FC<BundleHeaderBannerPurchaseDetailProps> = ({ bundleDetailSeo }) => {
  const { t } = useTranslation('store_course');
  const { name } = bundleDetailSeo;
  const { price, isBundleDetailLoading } = useBundleDetail();
  const { isEnrolled } = useBundleBanner();
  const { bundleCourses } = useBundleCourseItem();

  const { isDesktop } = useBreakpointV2();
  const theme = useTheme();

  const isDisableCoursePrice = isEnrolled;

  if (isBundleDetailLoading) {
    return (
      <BundleHeaderBannerPurchaseDetailContainer>
        <BundleHeaderPurchaseDetailSkeleton />
      </BundleHeaderBannerPurchaseDetailContainer>
    );
  }

  return (
    <BundleHeaderBannerPurchaseDetailContainer>
      <Box>
        <Typography variant="h5" color={theme.palette.textOnPrimary.secondary}>
          {t('bundle_detail.header_banner.bundle_with_count', { courseCount: bundleCourses.length })}
        </Typography>

        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: '12px' }}>
          <Typography
            sx={{
              typography: {
                md: 'h1',
                xs: 'h4',
              },
              color: theme.palette.textOnPrimary.primary,
              lineHeight: {
                lg: '43px',
                md: '36px',
              },
            }}
          >
            {name}
          </Typography>
          {/* TODO: implement like and share bundle */}
          {/* {!isDesktop && <LikeAndShareBundle bundleDetailSeo={bundleDetailSeo} />} */}
        </Box>

        {isDisableCoursePrice || !price ? null : (
          <BundleHeaderPrice salePrice={price?.salePrice} fullPrice={price?.fullPrice} />
        )}
      </Box>

      <Box>
        <BundleBannerPurchaseButton isDisableActionIcon={!isDesktop} bundleDetailSeo={bundleDetailSeo} />
      </Box>
    </BundleHeaderBannerPurchaseDetailContainer>
  );
};

export default BundleHeaderBannerPurchaseDetail;
